import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { DataCacheProvider } from './contexts/DataCacheContext';
import { PendingChangesProvider } from './contexts/PendingChangesContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Login from './pages/Login';
import Home from './pages/Home';
import TableEditor from './pages/TableEditor';
import Insights from './pages/Insights';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <DataCacheProvider>
            <PendingChangesProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route
                    path="/*"
                    element={
                      <ProtectedRoute>
                        <div className="min-h-screen bg-background dark:bg-background-dark transition-colors duration-200">
                          <Header />
                          <main className="container mx-auto px-4 py-8 pt-header">
                            <Routes>
                              <Route path="/" element={<Home />} />
                              <Route path="/table" element={<TableEditor />} />
                              <Route path="/table/:jobId" element={<TableEditor />} />
                              <Route path="/insights" element={<Insights />} />
                              <Route path="/insights/:jobId" element={<Insights />} />
                            </Routes>
                          </main>
                        </div>
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </BrowserRouter>
            </PendingChangesProvider>
          </DataCacheProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
